import type { CdwSelectOption } from '@cdw-ae/shared-interfaces';
import type { TreeNode } from '@cdw-ae/common-ui-components-tree';

export enum UpdateType {
  KEEP = 'keep',
  REPLACE = 'replace',
  APPEND = 'append',
  PREPEND = 'prepend',
  REMOVE = 'remove',
}

export enum FieldTemplate {
  TEXT = 'text',
  SELECT = 'select',
  TREE = 'tree',
}

export interface FieldUpdateType extends CdwSelectOption {
  value: UpdateType;
  shouldDisplayTemplate?: boolean;
}

/**
 * Validation configuration for a bulk edit field
 */
export interface FieldValidationConfig {
  /** Maximum character length for the field value */
  maxLength?: number;
  /** Regex pattern the value must match (used for Asset ID invalid char check) */
  pattern?: RegExp;
  /** Error message to display when pattern validation fails */
  patternErrorMessage?: string;
  /** Whether this field supports Append/Prepend operations (requires device data validation) */
  supportsAppendPrepend?: boolean;
}

export interface FieldUpdateConfig {
  updateTypes: FieldUpdateType[];
  name: CdwSelectOption;
  selectOptions?: CdwSelectOption[] | TreeNode[];
  template: FieldTemplate;
  /** Validation configuration for the field */
  validation?: FieldValidationConfig;
}
